(function () {
  'use strict';

  angular.module('ringbaPortal').component('urlParamForm', {
    bindings: {
      currentQueryPathMap: '<',
      onSave: '&',
      onDismiss: '&'
    },
    controller: UrlParamFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-url-params/url-param-form.view.html'
  });

  function UrlParamFormController(
    _,
    $filter,
    accountsService,
    queryPathMapService,
    campaignServiceNew,
    callbackService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;
    let currentQueryPathMap = undefined;

    vm.$onInit = onInit;
    vm.onSubmit = onSubmit;
    vm.cancel = cancel;

    function onInit() {
      _loadEventCallBackMacros();
      if (vm.currentQueryPathMap && vm.currentQueryPathMap.id) {
        currentQueryPathMap = vm.currentQueryPathMap;
        vm.currentQueryPathMap = angular.copy(vm.currentQueryPathMap);
      }
    }

    function onSubmit() {
      if (vm.currentQueryPathMap && !vm.currentQueryPathMap.id) {
        return _createQueryPathMap(vm.currentQueryPathMap);
      } else if (vm.currentQueryPathMap.id) {
        return _updateQueryPathMap(vm.currentQueryPathMap);
      }
    }

    function cancel() {
      const eventObj = vm.currentQueryPathMap ? {
        queryPathMap: currentQueryPathMap
      } : {};
      vm.onDismiss({
        $event: eventObj
      });
    }

    function _createQueryPathMap(queryPathMap) {
      return queryPathMapService.createQueryPathMap(accountsService.currentAccountId, queryPathMap)
        .then(function (response) {
          return vm.onSave({
            newURLParam: true,
            queryPathMap: response.data.queryPathMap
          });
        })
        .catch(utils.errorHandler);
    }

    function _updateQueryPathMap(queryPathMap) {
      return queryPathMapService.updateQueryPathMap(accountsService.currentAccountId, queryPathMap)
        .then(function () {
          toaster.pop('success', $filter('translate')('TAGS_UPDATE_SUCCESS'));
          vm.onDismiss({
            $event: {
              queryPathMap: queryPathMap
            }
          });
          vm.onSave({
            queryPathMap: queryPathMap
          });
        })
        .catch(utils.errorHandler);

    }

    function _loadEventCallBackMacros() {
      callbackService.getEventCallBackMacros(accountsService.currentAccountId)
        .then(function (response) {
          vm.macros = _.map(response.data.macros, 'name');
        })
        .catch(utils.errorHandler);
    }
  }
})();
